var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrganizerForm',{on:{"submit":_vm.update},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}}),_c('div',{staticClass:"vca-center"},[_c('vca-cancel-button',{attrs:{"placeholder":_vm.$t('button.delete')},on:{"click":function($event){return _vm.deleteOrganizer()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }